import { Component, Input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { IconModule } from '../../icon/icon.module';

@Component({
    selector: 'lc-datetime-display',
    template: `
        <ul class="flex items-center justify-center gap-2">
            <li class="flex items-center gap-2">
                <icon-calendar class="shrink-0 text-primary" />
                <div class="justify-start text-tertiary dark:text-gray-300 text-xs font-normal">
                    {{ formattedDate }}
                </div>
            </li>
            <li class="flex items-center gap-2">
                <icon-clock class="shrink-0 text-primary" />
                <div class="justify-start text-tertiary dark:text-gray-300 text-xs font-normal">
                    {{ formattedTime }}
                </div>
            </li>
        </ul>
    `,
    standalone: true,
    providers: [DatePipe],
    imports: [IconModule],
})
export class DatetimeDisplayComponent {
    @Input() date: Date | string | null = `${new Date()}`;

    constructor(private datePipe: DatePipe) {}

    get formattedDate(): string {
        return this.datePipe.transform(this.date, 'dd MMMM, yyyy', '', 'pt-BR') || '';
    }

    get formattedTime(): string {
        return this.datePipe.transform(this.date, 'hh:mma', '', 'pt-BR') || '';
    }
}
